// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Hidden from '@material-ui/core/Hidden';
import { getSketchOrders } from '../../actions/sketchOrdersActions';
import SketchOrderTable from '../../components/SketchOrderTable/SketchOrderTable';
import { SketchOrderStatusId } from '../../lib/sketchOrderStatuses';
import SketchOrderList from '../../components/SketchOrderList/SketchOrderList';
import { SketchOrderSortParameter as sketchOrderSortParameter } from '../../lib/sketchOrderSortParameters';
import { OrderParameter as orderParameter } from '../../lib/OrderParameters';
import OrdersTabs from '../OrdersTabs';

type SketchOrderSortParameter = $Keys<sketchOrderSortParameter>;
type OrderParameter = $Keys<orderParameter>;
type CurrentUserRoles = {
    isAdmin: boolean,
    isSketchOsAdmin: boolean,
    isSketchTech: boolean,
};
type ProvidedProps = {
    dispatch: Function,
    sketchOrders: Object,
    sketchOrderIds: Array<number>,
    totalResults: number,
    currentPage: number,
    totalPages: number,
    isFetching: boolean,
    currentUserRoles: CurrentUserRoles,
    currentUserName: string,
};
type State = {
    sort: SketchOrderSortParameter,
    order: OrderParameter,
};

export class QueuedSketchOrders extends Component<ProvidedProps, State> {
    state = {
        sort: sketchOrderSortParameter.DueDate,
        order: orderParameter.Ascending,
        filterStorm: false,
    };

    getSketchOrders = async (page: number = 1) => {
        await this.props.dispatch(getSketchOrders(
            page,
            [
                SketchOrderStatusId.Pending,
                SketchOrderStatusId.Queued
            ],
            null,
            null,
            this.state.order,
            this.state.sort,
            true,
            null,
            this.state.filterStorm,
        ));
    };

    async componentDidMount() {
        await this.getSketchOrders();
    }

    getNextPage = async () => {
        const nextPage = this.props.currentPage + 1;
        await this.getSketchOrders(nextPage);
    };

    getPrevPage = async () => {
        const prevPage = this.props.currentPage - 1;
        await this.getSketchOrders(prevPage);
    };

    handleOnSortClick = (sort: SketchOrderSortParameter, order: OrderParameter) => {
        this.setState({
            sort,
            order,
        }, async () => {
            await this.getSketchOrders();
        });
    };
    
    handleStormFilterClick = () => {
        this.setState({
            filterStorm: !this.state.filterStorm,
        }, async () => {
            await this.getSketchOrders();
        });
    };


    render() {
        const isSketchOsAdmin = () => this.props.currentUserRoles.isAdmin || this.props.currentUserRoles.isSketchOsAdmin;

        return (
            <div>
                <Hidden smDown>
                    <SketchOrderTable
                        sketchOrders={this.props.sketchOrders}
                        sketchOrderIds={this.props.sketchOrderIds}
                        totalOrders={this.props.totalResults}
                        currentPage={this.props.currentPage}
                        totalPages={this.props.totalPages}
                        onNextPageClick={this.getNextPage}
                        onPrevPageClick={this.getPrevPage}
                        showStatus
                        showDueDate
                        showProjectName={isSketchOsAdmin()}
                        showOrganizationName={isSketchOsAdmin()}
                        showLinksToSupportDashboard={this.props.currentUserRoles.isAdmin}
                        isFetching={this.props.isFetching}
                        canSortByRequestedDate
                        canSortByUpdatedDate
                        canSortByDueDate
                        sort={this.state.sort}
                        order={this.state.order}
                        onSortClick={this.handleOnSortClick}
                        currentUserName={this.props.currentUserName}
                        showTimeSinceRequested
                        showLastUpdatedAtTime
                        filterStormClick={this.handleStormFilterClick}
                        filterStorm={this.state.filterStorm}
                        showStormFilter
                    />
                </Hidden>
                <Hidden mdUp>
                    <SketchOrderList
                        sketchOrders={this.props.sketchOrders}
                        sketchOrderIds={this.props.sketchOrderIds}
                        totalOrders={this.props.totalResults}
                        currentPage={this.props.currentPage}
                        totalPages={this.props.totalPages}
                        onNextPageClick={this.getNextPage}
                        onPrevPageClick={this.getPrevPage}
                        showOrganizationName={isSketchOsAdmin()}
                        isFetching={this.props.isFetching}
                        filterStormClick={this.handleStormFilterClick}
                        filterStorm={this.state.filterStorm}
                        showStormFilter
                    />
                </Hidden>
            </div>
        );
    }
}



const mapStateToProps = (state) => {
    const { sketchOrders: sketchOrdersStore, currentUserRoles, currentUser } = state;
    const {
        sketchOrders,
        totalResults,
        currentPage,
        totalPages,
        isFetching,
        ids: sketchOrderIds,
    } = sketchOrdersStore;
    const { userName: currentUserName } = currentUser;
    return {
        sketchOrders,
        sketchOrderIds,
        totalResults,
        currentPage,
        totalPages,
        currentUserRoles,
        isFetching,
        currentUserName,
    }
};

export default connect(mapStateToProps)(QueuedSketchOrders);
